import { Avatar as AntAvatar } from "antd";
import React, { useMemo } from "react";
import "./style.scss";

interface AvatarProps {
  url?: string;
  name?: string;
  userID?: string;
  size?: number | "small" | "default" | "large";
  className?: string;
  icon?: React.ReactNode | React.ElementType;
  shape?: "circle" | "square";
  color?: string;
}

const Avatar: React.FC<AvatarProps> = ({
  url,
  size = 32,
  className = "",
  icon,
  color,
  name,
  userID,
  shape = "circle", // Default shape is circle
}) => {
  let finalIcon: React.ReactNode = undefined;

  if (icon) {
    if (React.isValidElement(icon)) {
      finalIcon = icon;
    } else if (typeof icon === "function" || typeof icon === "object") {
      finalIcon = React.createElement(icon as React.ElementType);
    }
  }

  // First character fallback (if no url and no icon)
  const fallbackText =
    !url && !finalIcon && name ? name.charAt(0).toUpperCase() : undefined;

  const backgroundColor = useMemo(() => {
    if (color) return color; // 👈 override if provided

    if (!url && !finalIcon && name) {
      const antColors = [
        "#f56a00",
        "#7265e6",
        "#ffbf00",
        "#00a2ae",
        "#87d068",
        "#1890ff",
        "#eb2f96",
        "#fa541c",
        "#76B0BA",
      ];
      const index = name.charCodeAt(0) % antColors.length;
      return antColors[index];
    }
    return undefined;
  }, [url, finalIcon, name, color]);

  return (
    <div className={`avatar-wrapper flex items-center ${className}`}>
      <AntAvatar
        size={size}
        src={url ? url : undefined}
        icon={finalIcon}
        shape={shape}
        style={{ backgroundColor }}
      >
        {fallbackText}
      </AntAvatar>

      {name && (
        <div className="flex flex-col">{userID && <span>{userID}</span>}</div>
      )}
    </div>
  );
};

export default Avatar;
